<template>
  <div id="homeowner-benefits" class="default-layout">

    <header>
      <nav id="navbar">
        <div class="nav">
            <router-link to="/home" class="nav-item">Back</router-link>
            <router-link to="/home" class="nav-item">Home</router-link>
        </div>
        <div class="logo">
            <img src="@/assets/images/navbar-logo.svg" alt=""/>
        </div>
      </nav>
    </header>
    
    <main>
      <div class="page-header">
        <p class="eyebrow">Discover our product</p>
        <h1>What is <br/> SmartAC.com</h1>
      </div>

      <section class="pt-0">
        <video ref="video" controls poster="@/assets/images/cartoon-dude-couch.jpg" autoplay="false" id="overview-video" class="fullwidth">
          <source src="@/assets/videos/smartac-overview.mp4" type="video/mp4">
        </video>
      </section>

      <section class="fullwidth">
        <img src="@/assets/images/smarthub-table-plant.jpg" alt="SmartHub on the table">
        <img src="@/assets/images/comfort-sensor-closeup-vent.jpg" alt="Comfort sensor vent placement" class="mt-4">
      </section>

      <section>
        <ul class="bullet-list">
          <li><img src="@/assets/images/list-item-bullet.png" alt="bullet" class="bullet">Predicts breakdowns before they happen</li>
          <li><img src="@/assets/images/list-item-bullet.png" alt="bullet" class="bullet">Catches small problems before they become expensive</li>
          <li><img src="@/assets/images/list-item-bullet.png" alt="bullet" class="bullet">Detects water leaks before catastrophic damage</li>
          <li><img src="@/assets/images/list-item-bullet.png" alt="bullet" class="bullet">Tracks filter health percentage to optimize replacements</li>
          <li><img src="@/assets/images/list-item-bullet.png" alt="bullet" class="bullet">Monitors HVAC system health through real-time data</li>
          <li><img src="@/assets/images/list-item-bullet.png" alt="bullet" class="bullet">Provides transparency with your service providers</li>
        </ul>
      </section>

      <section class="fullwidth">
        <img src="@/assets/images/filter-sensor-vent.jpg" alt="">
      </section>

      <section>
        <FeatureList/>
      </section>

      <section class="fullwidth">
        <img src="@/assets/images/water-sensor-drain-pan.jpg" alt="">
        <img src="@/assets/images/sensor-group.jpg" alt="" class="my-4">
        <img src="@/assets/images/app-key-screenshots.jpg" alt="">
      </section>

    </main>

    <Footer/>
    
  </div>
</template>

<script>
    import Footer from '@/components/Footer.vue'
    import FeatureList from '@/components/FeatureList.vue'
    
    export default {
        components: {
            Footer,
            FeatureList,
        },
        data (){
            return {
            }
        },
        mounted() {
            this.$refs.video.pause(); //Pauses video on app mount
        }
    }
</script>